export const HEADER_TOP_ENDORNMENT = '28px';
